const APP_VERSION = "0.429"

export default APP_VERSION;
